import { render } from "./ProjectProfileListPage.vue?vue&type=template&id=12aab299&ts=true"
import script from "./ProjectProfileListPage.vue?vue&type=script&lang=ts"
export * from "./ProjectProfileListPage.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__